import React from 'react';

import { useNavigate } from 'react-router-dom';

import { Button, Tabs, TabsContent, TabsList, TabsTrigger } from '#/components/ui';
import { useAppContext } from '#/context';
import { ROUTES } from '#/routes';
import { Companies, Employees } from '..';

const Home = () => {
    const { user, Filters } = useAppContext();

    const { company, employee } = Filters || {};

    const navigate = useNavigate();
    const { contactsCount } = user || {};
    const navigateToContacts = () => {
        navigate(ROUTES.MY_CONTACTS);
    };
    /**
     * @example
     * const { data, isLoading, error } = useGetQuery({
     *   key: 'users',
     *   url: '/api/users',
     *   params: { role: 'admin' },
     * });
     */

    return (
        <div className='py-5 bg-white rounded-lg shadow-md'>
            <Tabs defaultValue='companies' className=''>
                <div className='flex justify-between border-b-2 border-gray200 mx-5'>
                    <TabsList className='space-x-4'>
                        <TabsTrigger value='companies' className='text-2xl pb-4 px-1 font-semibold'>
                            Companies List
                        </TabsTrigger>
                        <TabsTrigger value='decision-makers' className='text-2xl pb-4 px-1 font-semibold'>
                            Decision Makers
                        </TabsTrigger>
                    </TabsList>
                    <Button className='text-sm font-medium font-dmSans -mt-2' onClick={navigateToContacts}>
                        Visit My Contacts ({contactsCount})
                    </Button>
                </div>

                <TabsContent value='companies'>
                    <Companies companyFilters={company} />
                </TabsContent>
                <TabsContent value='decision-makers'>
                    <Employees employeeFilters={employee} />
                </TabsContent>
            </Tabs>
        </div>
    );
};

export { Home };
